type DebounceFn = (
    fn: () => unknown,
    timeout?: number
) => {
    run: () => void;
    stop: () => void;
};

export const debounce: DebounceFn = (func: () => unknown, timeout = 1000) => {
    let interval = 0;
    const stop = () => clearInterval(interval);
    const run = () => {
        stop();
        interval = window.setTimeout(func, timeout);
    };
    return { run, stop };
};
